import axiosToken from "../../api/axiosClient";
import { buildQueryString } from "../../utils/reportUtils";

class GiftcardReportService {
  async getSummary(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/giftcards/summary${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  async getList(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/giftcards/list${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  async getUsage(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/giftcards/usage${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  _handleError(error) {
    return {
      message: error.response?.data?.error || "Erreur cartes cadeaux",
      status: error.response?.status,
    };
  }
}

export default new GiftcardReportService();
